import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { PaymentStatus } from '@services/gql.service';
import { Utils } from '@services/utils';
import { InvoicesGridFormatterService } from './invoices-grid-formatter.service';

@Component({
  template: `
    <div class="flex items-center whitespace-nowrap">
      <div class="w-3 h-3 rounded-full mr-1" [ngClass]="bgClass"></div>
      <div [ngClass]="textClass" class="mr-1">{{ status }}</div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentStatusComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  status!: string;

  bgClass!: string;

  textClass!: string;

  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: PaymentStatus | string = params.data?.payment_status || params.value || '';

    if (params.node?.rowPinned) {
      this.textClass = '';
      this.status = Utils.zeroHyphen;

      return;
    }

    const {
      bgClass,
      label,
      textClass,
    } = InvoicesGridFormatterService.getInvoicePaymentStatusStyles(status);

    this.bgClass = bgClass;
    this.status = label;
    this.textClass = textClass;
  }
}
